// src/hooks/hotelRoomCategories/useUpdateHotelRoomCategory.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { updateHotelRoomCategory } from "../../api/apiHotelRoomCategories";
import { useNavigate } from "react-router-dom";
import parseError from "../../utils/parseError";

const useUpdateHotelRoomCategory = () => {
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    const { mutate: editHotelRoomCategories, isPending: isUpdate } = useMutation({
        mutationFn: ({ id, req }) => updateHotelRoomCategory(req, id),
        onSuccess: (res) => {
            const message = res?.message || "Hotel room category updated successfully";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["hotelRoomCategories"] });
            queryClient.invalidateQueries({ queryKey: ["hotelRoomCategory"] });
            navigate("/hotel-room-categories");
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to update hotel room category");
        },
    });

    return { editHotelRoomCategories, isUpdate };
};

export default useUpdateHotelRoomCategory;
